import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import Image from '../components/Image';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Bueno, ya aprendimos aunque sea lo básico para poder consultar data en GraphQL,
ahora les tengo que dar una mala noticia, todo eso `}<del parentName="p">{`no sirvió para nada`}</del>{` nos
sirve un montón! 🤣 Nah, la mala noticia es que vamos a tener que usar una
versión de GraphiQL vieja en la página de Github que no tiene el Explorer de la
izquierda que tenemos con Gatsby que es SUPER UTIL y ayuda un montón.`}</p>
    <p>{`Vamos a `}<a parentName="p" {...{
        "href": "https://developer.github.com/v4/explorer/"
      }}>{`la API GraphQL de Github`}</a>{`!`}</p>
    <Image imgName="ghgraphql.png" alt="Github GraphQL API" mdxType="Image" />
    <p>{`Esto es un poco más complicado pero si hacemos click arriba a la derecha en
`}<strong parentName="p">{`Docs`}</strong>{`, vamos a ver un poco de info sobre qué estamos consultando. Si borramos
viewer y login (y sus respectivas llaves) podemos ver lo que nos sugiere
GraphiQL si empezamos a tipear. O sino tenemos la
`}<a parentName="p" {...{
        "href": "https://developer.github.com/v4/"
      }}>{`docu de la API GraphQL de Github`}</a>{`, pero mejor
pensemos juntos y vamos viendo qué estamos necesitando.`}</p>
    <p>{`La data que traigamos con la query que hagamos acá, es la data que después vamos
a tener disponible en nuestro backend (creo que ya lo dije, no? jaja), así que
veamos, nosotros necesitamos traer nuestros repos, entonces escribamos eso en
nuestra query:`}</p>
    <Image imgName="repos.png" alt="Github GraphQL API query" mdxType="Image" />
    <p><strong parentName="p">{`BUENO ESO DE LOS REPOS ERA MENTIRA`}</strong>{`, borren eso y como dije antes, lean la
documentación de todo lo que usen. 😂`}</p>
    <p>{`Por practicidad y para no hacerles perder el tiempo, hagamos bien la query.
Nosotros sí necesitamos los repos, pero `}<strong parentName="p">{`de cierto usuario`}</strong>{` (`}<em parentName="p">{`el nuestro`}</em>{`),
así que borremos "repos" y escribamos "user", lo cual nos va a sugerir un dato
de ese tipo, cliqueemos para seleccionarlo. Ahora posicionemos nuestro puntero
del mouse sobre user un par de segundos y veremos que nos aparece un cartel
explicando el tipo de dato que estamos consultando, hagamos click en el "user"
azul, lo cual nos despliega la documentación sobre ese dato.`}</p>
    <Image imgName="queryuser.png" alt="Querying the user in github" mdxType="Image" />
    <p>{`Ahí a la derecha vemos los argumentos que acepta este dato, que sería `}<strong parentName="p">{`login:
String!`}</strong>{`. Esto nos indica que vamos a tener que indicar un String con clave
`}<strong parentName="p">{`login`}</strong>{` y el signo de exclamación `}<strong parentName="p">{`!`}</strong>{` indica que este valor es `}<em parentName="p">{`requerido`}</em>{`,
así que nos debería quedar algo así:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`query `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token function"
          }}>{`user`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`login`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"agustinmulet"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//Acá seguimos`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Obviamente pongan entre comillas `}<strong parentName="p">{`su usuario`}</strong>{` 😜 sigamos, ya sabemos que vamos
a recibir algo de cierto user, necesitamos ahora sí que sean los repos!
Escribamos "repos" ahora en serio 🤣. Esto nos va a sugerir, entre otras cosas,
`}<em parentName="p">{`repository`}</em>{` y `}<em parentName="p">{`repositories`}</em>{`, si necesitamos lo`}<strong parentName="p">{`s`}</strong>{` repositorio`}<strong parentName="p">{`s`}</strong>{`, cuál les
parece que vamos a necesitar? 😉`}</p>
    <p>{`Si hacemos lo mismo que con `}<em parentName="p">{`user`}</em>{` antes, podemos ver los argumentos que podemos
usar con lo que nos estamos trayendo. Si eligieron bien, deberíamos ver varios
como privacy, orderBy, affiliations, etc. No sé a ustedes, pero a mi me gustó
que esté primero privacy, ya que nosotros solamente vamos a querer mostrar
nuestros repos públicos, así que agreguemos ese filtro, escribamos `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`(privacy: )`}</code>{`
y les cuento un truquito: aprieten `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Ctrl + barra espaciadora`}</code>{` y les va a sugerir
los distintos tipos de repos que acepta `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`privacy`}</code>{`, esto nos va a simplificar el
laburo 😄`}</p>
    <p>{`Si hicimos todo bien, presionando Ctrl + barra adentro deberíamos tener algo
así:`}</p>
    <Image imgName="privacy.png" alt="Consultando repos Github API" style={{
      width: '50vw',
      margin: '0 auto'
    }} mdxType="Image" />
    <p><strong parentName="p">{`KESESO? edges, nodes, whaaattt???`}</strong>{` Bueno, acá les voy a explicar algo como yo
lo entiendo y como me viene funcionando: cuando queremos traernos una colección
de cosas, en este caso de nuestros repositorios, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`edges`}</code>{` representa la colección
o el `}<strong parentName="p">{`array`}</strong>{` y dentro de `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`edges`}</code>{`, un dato llamado `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node`}</code>{` va a representar
`}<strong parentName="p">{`cada objeto`}</strong>{` dentro de esa colección o array. Se entiende? Quizás cuesta un
poco al principio pero cuanto más usemos GraphQL más se afianzan todos estos
conceptos.`}</p>
    <p>{`Ahora bien, nosotros necesitamos ese array, así que vayamos con los `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`edges`}</code>{` y
dentro consultemos por cada `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`node`}</code>{`, que representa cada uno de nuestros repos 😎
ya casi estamos, no me odien jaja. Si hacemos Ctrl + barra vemos un
montó´´oóóóón de datos que podemos traer de cada repo, elijan los que les
parezcan más útiles de mostrar! Ahora denle al botoncito de "Play" de arriba
y... `}<strong parentName="p">{`Momento, esto tira error, Agustin ahora sí te odio 🤬🤬😡`}</strong>{` Pero 😢 lean
mejor el mensaje de error que les dice GraphiQL! Falta proveer un dato `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`first`}</code>{` o
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`last`}</code>{` a los `}<em parentName="p">{`repositories`}</em>{`, hagamos eso, sumemos al lado de `}<em parentName="p">{`privacy`}</em>{` y
pongamos por ejemplo `}<strong parentName="p">{`first: 50`}</strong>{` (no sé ustedes pero yo no tengo más de 15-20
repos en mi cuenta) Demos "Play" de nuevo y veremos nuestros hermosos repos en
cualquier orden 🤣 Podemos ordenarlos con el filtro `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`orderBy`}</code>{`, pero ya les dejo
a ustedes que ordenen como les guste 😀 Les dejo cómo hice yo mi query y cómo
debería quedar el `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{` acá abajo 👇`}</p>
    <Tabs mdxType="Tabs">
      <TabList mdxType="TabList">
    <Tab mdxType="Tab">Soluciones</Tab>
    <Tab mdxType="Tab">Mi query</Tab>
      </TabList>
      <TabPanels mdxType="TabPanels">
        <TabPanel mdxType="TabPanel">Para ver la solución hacé click en la pestaña 👆</TabPanel>
        <TabPanel mdxType="TabPanel">
          <div {...{
            "className": "gatsby-highlight",
            "data-language": "javascript"
          }}><pre parentName="div" {...{
              "className": "language-javascript"
            }}><code parentName="pre" {...{
                "className": "language-javascript"
              }}>{`graphQLQuery`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`query {
  user (login:"agustinmulet"){
  repositories(first:50,orderBy:{field:STARGAZERS, direction:DESC},privacy:PUBLIC){
    edges {
      node {
        id
        name
        description
        isPrivate
        url
      	}
    	}
  	}
  }
}`}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
`}</code></pre></div>
        </TabPanel>
      </TabPanels>
    </Tabs>
    <p>{`Ahora, como modificamos uno de los archivos de Gatsby, debemos frenar el
servidor local haciendo `}<strong parentName="p">{`Ctrl + C`}</strong>{` y volver a levantarlo corriendo `}<strong parentName="p">{`gatsby
develop`}</strong>{`. Vayamos a GraphiQL en http://localhost:8000/___graphql y si vemos a
la izquierda, veremos que tenemos algo nuevo para consultar: `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`allGithubData`}</code>{` y
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`githubData`}</code>{`! 😃 Genial, ahora les dejo armar la query para usar en el frontend,
les dejo como tip que usen `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`githubData`}</code>{` y no la que sería `}<strong parentName="p">{`all`}</strong>{` ya que esa
sería por si traemos cosas de varios usuarios, nosotros tenemos uno, así que nos
alcanza con consultar la data de `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`githubData`}</code>{` nomás. Otra cosa a tener en
cuenta: las queries pueden tener nombre o no, `}<strong parentName="p">{`query Nombre {}`}</strong>{`, lo que sí,
hay que tener en cuenta que esos nombres `}<strong parentName="p">{`no se pueden repetir`}</strong>{` en nuestro
proyecto.`}</p>
    <p>{`Bueno, con el ejemplo del uso de query + uso de datos en el front en el
componente `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`layout.js`}</code>{`, les dejo pensar y hacer la query de nuestros repos y
mostrar esa data. Pueden hacer un componente nuevo si quieren, o en una `}<em parentName="p">{`page`}</em>{`,
lo que más les guste. Les dejo mi componente acá 👇 y pasamos a la siguiente
parte.`}</p>
    <Tabs mdxType="Tabs">
      <TabList mdxType="TabList">
    <Tab mdxType="Tab">Soluciones</Tab>
    <Tab mdxType="Tab">misrepos.js</Tab>
      </TabList>
      <TabPanels mdxType="TabPanels">
        <TabPanel mdxType="TabPanel">Para ver la solución hacé click en la pestaña 👆</TabPanel>
        <TabPanel mdxType="TabPanel">
          <div {...{
            "className": "gatsby-highlight",
            "data-language": "jsx"
          }}><pre parentName="div" {...{
              "className": "language-jsx"
            }}><code parentName="pre" {...{
                "className": "language-jsx"
              }}><span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` React `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` useStaticQuery`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` graphql `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'gatsby'`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` `}<span parentName="code" {...{
                  "className": "token function-variable function"
                }}>{`MisRepos`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` repos `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`useStaticQuery`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`graphql`}<span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`
    query MisReposQuery {
      githubData {
        data {
          user {
            repositories {
              edges {
                node {
                  description
                  id
                  isPrivate
                  name
                  url
                }
              }
            }
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  console`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function"
                }}>{`log`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`repos`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`githubData`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`data`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`user`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`repositories`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`edges`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`return`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`table`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
      `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`thead`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
        `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`tr`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
          `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`repo.id`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
          `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`repo.name`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
          `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`repo.isPrivate`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
          `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`repo.url`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
          `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`repo.description`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`th`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
        `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`tr`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
      `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`thead`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
      `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`tbody`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
        `}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`repos`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`githubData`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`data`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`user`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`repositories`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`edges`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function"
                }}>{`map`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token parameter"
                }}><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`{`}</span>{` node `}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`}`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`tr`}</span>{` `}<span parentName="span" {...{
                    "className": "token attr-name"
                  }}>{`key`}</span><span parentName="span" {...{
                    "className": "token script language-javascript"
                  }}><span parentName="span" {...{
                      "className": "token script-punctuation punctuation"
                    }}>{`=`}</span><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`{`}</span>{`node`}<span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`.`}</span>{`id`}<span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`}`}</span></span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
            `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`id`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
            `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`name`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
            `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`isPrivate `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`?`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'Privado'`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'Público'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
            `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`url`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
            `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`<`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`description`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`td`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
          `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`tr`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span>{`
        `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
      `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`tbody`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span><span parentName="code" {...{
                  "className": "token plain-text"
                }}>{`
    `}</span><span parentName="code" {...{
                  "className": "token tag"
                }}><span parentName="span" {...{
                    "className": "token tag"
                  }}><span parentName="span" {...{
                      "className": "token punctuation"
                    }}>{`</`}</span>{`table`}</span><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`export`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`default`}</span>{` MisRepos`}</code></pre></div>
        </TabPanel>
      </TabPanels>
    </Tabs>
    <h2>{`Subiendo nuestro proyecto a Netlify`}</h2>
    <p>{`Gatsby + Netlify = 💝💞`}</p>
    <p>{`Bueno, como hablamos de la privacidad, antes de subir nuestro proyecto a
cualquier lado, estaría bueno preservar nuestra key de Github así no viene
cualquiera y lo usa para cualquier cosa. Usemos entonces variables de entorno 😉
Empecemos por crear un archivo que se llame `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.env.development`}</code>{` (sí, empieza con
punto) en la raíz de nuestro proyecto (a la misma altura que los archivos
`}<strong parentName="p">{`gatsby-algo.js`}</strong>{`) y luego agreguémoslo en nuestro archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.gitignore`}</code>{` así nos
aseguramos que no subimos ese archivo a nuestro Github. Adentro de este archivo
`}<strong parentName="p">{`.env.development`}</strong>{` vamos a generar una variable de entorno que su nombre
`}<strong parentName="p">{`DEBE EMPEZAR con`}</strong>{` `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`GATSBY_`}</code>{`, por ejemplo:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token constant"
          }}>{`GATSBY_GH_KEY`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`079`}</span>{`b55830a613c38aff7f4608ef2448d83db9758`}</code></pre></div>
    <p>{`Guardamos y Gatsby como con muchas cosas, ya tiene `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`dotenv`}</code>{` preconfigurado, así
que para poder acceder a nuestro archivo recién generado y a la variable de
entorno agreguemos en nuestro archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby-config.js`}</code>{` lo siguiente:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'dotenv'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`config`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`.env.`}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`process`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span>{`env`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token constant"
              }}>{`NODE_ENV`}</span><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Y luego en el mismo archivo podemos modificar la configuración del token de
nuestro plugin de Github por esto:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`token`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` process`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`env`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token constant"
          }}>{`GATSBY_GH_KEY`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span></code></pre></div>
    <p>{`Et voilà! Si bajamos el servidor de desarrollo y lo volvemos a levantar, debería
seguir funcionando todo normalmente. Ahora nos resta subir nuestro proyecto a
Github con nuestra key guardadita y a salvo, para eso comencemos por entrar a
nuestro usuario de Github, a la parte de repositorios y creemos uno nuevo con el
botón verde `}<strong parentName="p">{`New`}</strong>{` que está a la derecha, o
`}<a parentName="p" {...{
        "href": "https://www.github.com/new"
      }}>{`entrando en este link`}</a>{`. Luego escribimos un nombre
para nuestro repositorio `}{`(`}{`por ejemplo "MiPortfolio"`}{`)`}{` y no hace falta que
pongamos descripción ni que lo inicialicemos con un README. Vamos al botón de
abajo de todo y terminamos de crear nuestro repositorio. Se nos va a crear un
repositorio vacío y el mismo Github que es re copado nos va a decir cómo subir
nuestro proyecto donde dice
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`…or push an existing repository from the command line`}</code>{`. Entonces abrimos una
terminal y vamos hasta la carpeta raíz de nuestra app, luego ahí hacemos lo que
nos dice Github:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` remote `}<span parentName="code" {...{
            "className": "token function"
          }}>{`add`}</span>{` origin https://github.com/agustinmulet/MiPortfolio.git
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`git`}</span>{` push -u origin master`}</code></pre></div>
    <p>{`Es probable que nos pida nuestro usuario y constraseña de Github, en ese caso
ingresamos nuestras credenciales y si todo salió bien, ya tenemos nuestra app
subida a un repo propio!`}</p>
    <p>{`Ahora resta hacernos una cuenta en `}<a parentName="p" {...{
        "href": "https://www.netlify.com"
      }}>{`Netlify`}</a>{` para subir
nuestro proyecto, para hacerlo hay que entrar con nuestro usuario a Netlify,
hacer click en el botón verde de arriba a la derecha que dice `}<strong parentName="p">{`New site from
Git`}</strong>{` e indicarle cuál es el repositorio con nuestra app `}{`(`}{`MiPortfolio si le
pusieron el mismo nombre que yo`}{`)`}{`, aceptamos y continuamos con las
configuraciones que detecta automáticamente Netlify (sí, es re copado e
inteligente), esperamos un poco que haga el deploy y ya `}{`(`}{`casi`}{`)`}{` está! Lo que
sí, Netlify nos da un nombre raro para nuestro sitio, así que para cambiar el
nombre al que querramos `}{`(`}{`nombredeapp.netlify.com`}{`)`}{`, tenemos que `}{`(`}{`si es que
estamos en el Dashboard principal de Netlify`}{`)`}{` hacer click en nuestra app recién
subida con nombre raro, hacer click en el botón `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`⚙ Site Settings`}</code>{` y en la parte
de `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Site Information`}</code>{` vamos a ver otro botón `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Change site name`}</code>{`, donde podemos
definir el nombre que querramos. Es probable que algún nombre como MiPortfolio
esté utilizado, pero podemos inventar algo usando nuestro nombre, o algún nombre
raro que se les ocurra `}{`(`}{`elmejorportfolio, wowsomuchportfolio,
lamejorwebamiguis, loquesea jaja`}{`)`}{`.`}</p>
    <p>{`Es probable que nuestro deploy falle, porque nuestra variable de entorno no
existe. Vamos entonces a agregar nuestra variable de entorno en Netlify. Para
esto volvemos a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`⚙ Site Settings`}</code>{` de nuestro proyecto y ahí dentro a
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Build & deploy`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Environment`}</code>{` y creamos una nueva haciendo click en el botón
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Edit variables`}</code>{`. Nos pide Clave / Valor, por practicidad vamos a poner como
clave el nombre que venimos usando `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`GATSBY_GH_KEY`}</code>{`y como valor ponemos nuestra
API key `}<strong parentName="p">{`079b55830a613c38aff7f4608ef2448d83db9758`}</strong>{` todo así sin comillas,
solamente el texto.`}</p>
    <p>{`Guardamos y es posible que tengamos que repetir el tema del deploy, pero es la
forma que conozco de hacerlo funcionar... Para repetir el deploy, vamos al menú
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`Deploys`}</code>{` y a la derecha vemos un dropdown que dice `}<strong parentName="p">{`Trigger deploy`}</strong>{`, hacemos
click ahí y luego en `}<strong parentName="p">{`Deploy site`}</strong>{`. Esperamos un rato y deberíamos tener todo
subido y funcionando 😎`}</p>
    <p>{`Ahora resta ponerlo lindo usando css, mostrando todo en cards, imágenes, lo que
les parezca, eso se los dejo a ustedes!`}</p>
    <p>{`Y si todavía andás con tiempo y ganas, seguí avanzando y hacemos el blog! 😉😉😉`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      